import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Deal, DealsActionData } from '../../../clients/interface/data.interface';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DetailDealComponent } from '../../../files-clients/components/cmfdeals/detail-deal/detail-deal.component';
import { AuthService } from 'src/app/pages/authentication/service/auth.service';
import { environment } from 'src/environments/enviroments';
import { CompaniesFactoringService } from '../../../factoring/services/companies-factoring.service';
import { ConfigRutService } from 'src/app/services/config-rut.service';
import Swal from 'sweetalert2';
import { ValidClient } from '../../../factoring/interface/data.interface';

@Component({
  selector: 'app-table-deals',
  templateUrl: './table-deals.component.html',
  styleUrls: ['./table-deals.component.scss']
})
export class TableDealsComponent {
  @ViewChild(MatPaginator, { static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true}) sort: MatSort;
  @Input() deals: Deal[];
  @Input() page: number;
  @Input() pageSize: number;
  @Input() totalRows: number;
  @Input() sortColumn: string;
  @Input() sortDirection: string;
  @Input() estadoTrato: string;
  @Input() estadoResolutivo: string;
  @Output() pagination = new EventEmitter<any>;
  @Output() sorting = new EventEmitter<any>;
  @Output() updateDeals = new EventEmitter<any>;
  public dataSource: MatTableDataSource<Deal> = new MatTableDataSource([]);
  public booleanFlag = true;
  public dataDeal: DealsActionData;
  public instance;
  public estadoResolutivoMostrar;
  public estadoTratoMostrar;
  public horaActual = new Date();
  public userId: number;
  public productTypes;

  public displayCols = [
    'companyName',
    'finalidad',
    'name',
    'executiveName',
    'fechaCreacion',
    'ultimaFecha',
    'dealAmount',
    'comision',
    'tags',
    //'position'
  ];

  constructor(private auth: AuthService, private cdr: ChangeDetectorRef, private dialog: MatDialog, private authService: AuthService, private companyService: CompaniesFactoringService, private configuracionRut: ConfigRutService){
  }

  ngOnInit(): void {
    this.userId = parseInt(this.auth.getRutUser());
    this.setDataSource();
    this.setSorting();

    this.estadoResolutivoMostrar = this.estadoResolutivo;
    this.estadoTratoMostrar = this.estadoTrato;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['deals'] && changes['deals'].currentValue) {
      this.setDataSource(); 
      if(this.instance != undefined && this.deals != undefined) {
        this.instance.updateDeals(this.deals);
      }
    }
  }

  ngAfterViewInit(): void {
    this.paginator = this.paginator;
  }

  public changePagination(event: PageEvent) {
    const pagination = {
      page: event.pageIndex + 1,
      pageSize: event.pageSize
    };
    this.pagination.emit(pagination);
  }

  public changeSorting(sortState: Sort): void {
    if(sortState.direction === '') {
      this.sorting.emit(null);
      return;
    }

    const sorting =  {
      sortColumn: sortState.active,
      sortDirection: sortState.direction.toLowerCase()
    };
    this.sorting.emit(sorting);
  }

  private setDataSource() {
    if (this.deals) {
      this.dataSource.data = this.deals;
      this.paginator.pageIndex = this.page - 1;
      this.paginator.pageSize = this.pageSize;
      this.paginator.length = this.totalRows;
      this.booleanFlag = false;
    }
  }

  private setSorting() {
    this.sort.active = this.sortColumn;
    if(this.sortDirection)
      this.sort.direction = this.sortDirection === 'asc' ? 'asc': 'desc';
  }

  public openModalDetaiDeals(data: any) {
    var emailUser = this.authService.getEmailIdentifier();
    this.dataDeal = {
      userId: emailUser,
      dealId: data.id,
      actions: data.actions
    };

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.width = '82vw';
    //dialogConfig.height = '76vh';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '85vh';
    dialogConfig.data = this.dataDeal;
    var ref = this.dialog.open(DetailDealComponent, dialogConfig);

    this.instance = ref.componentInstance;
    this.instance.dealUpdated.subscribe((updated: boolean) => {
      if (updated) {
        this.loadDealsAndUpdateModal(this.instance);
      }
    });
  }

  public async loadDealsAndUpdateModal(modalInstance: DetailDealComponent) {
    this.updateDeals.emit();
  }

  public updateDealsEval(updatedDeals: any) {
    if (updatedDeals) {
      const deal = updatedDeals.results.find((action: any) => action.id == this.dataDeal.dealId);
      this.dataSource.data = deal.actions; 
      this.cdr.detectChanges();
    } else {
      console.error("No se pudieron actualizar los tratos. Datos no válidos.");
    }
  }

  public redirectDashbardClient(rut: string) {
    Swal.fire({
      title: 'Por favor espera...',
      text: 'Te estamos redigiendo al Cliente.',
      allowOutsideClick: false, 
      didOpen: () => {
        Swal.showLoading(); 
      },
    });

    var companyId = rut.substring(0, rut.length - 1);
    var companyRut = this.validarRut(parseInt(companyId));
    const requestBody: ValidClient = {
      //companyRut: this.validarRut(parseInt(companyId)),
      companyRut: companyRut,
      typeCompany: 'isClient',
      userId: this.userId,
    };

    this.companyService.validClient(requestBody).subscribe({
      next: (e) => {
        Swal.close();
        window.open('dashboards/files-clients?client='+companyId, '_blank');
      },
      error: (err) => {
        this.booleanFlag = false;
        console.log(err);
      }
    });
  }

  public validarRut(rut): any {
    console.log(rut);
    var formattedRut = this.configuracionRut.formatRutWithDv(rut);
    return formattedRut;
  }

  public redirectDealCRM(idDeal: string) {
    window.open(environment.apiUrlCRM + idDeal, '_blank');
  }

  public esMayorA4Horas(ultimaFecha: Date): boolean {
    const diferenciaMs = this.horaActual.getTime() - new Date(ultimaFecha).getTime();
    const horas = diferenciaMs / (1000 * 60 * 60); // Convierte a horas
    return horas > 4;
  }

}